import { render, staticRenderFns } from "./vue-renderer-component.vue?vue&type=template&id=1686b0a4&scoped=true"
import script from "./vue-renderer-component.vue?vue&type=script&lang=js"
export * from "./vue-renderer-component.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1686b0a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/graphileon/graphileon/release/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1686b0a4')) {
      api.createRecord('1686b0a4', component.options)
    } else {
      api.reload('1686b0a4', component.options)
    }
    module.hot.accept("./vue-renderer-component.vue?vue&type=template&id=1686b0a4&scoped=true", function () {
      api.rerender('1686b0a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/renderers/vue-components/vue-renderer-component.vue"
export default component.exports